(()=>{
 const data=window.CVC_COMMERCE||{},native=window.CVC_SHOPIFY===true&&!window.CVC_STATIC_PREVIEW;
 const root=window.Shopify?.routes?.root||'/',store='https://cozyvibesco.com';
 let busy=false,previousFocus;
 function refreshPrices(){
  document.querySelectorAll('[data-cvc-offer-price]').forEach(el=>{const offer=data[el.dataset.cvcOfferPrice];if(offer)el.textContent=offer.priceText;});
  document.querySelectorAll('[data-cvc-add],[data-cvc-buy]').forEach(el=>{
   const offer=data[el.dataset.cvcAdd||el.dataset.cvcBuy];
   if(!offer)return;
   const buy=el.hasAttribute('data-cvc-buy');
   el.href=store+'/cart/'+offer.variantId+':1'+(buy?'':'?storefront=true');
   if(!native){el.target='_blank';el.rel='noopener';}
   if(offer.available===false){el.setAttribute('aria-disabled','true');el.textContent='Currently unavailable';}
  });
 }
 const dialog=document.createElement('dialog');dialog.className='cvc-cart-feedback';dialog.setAttribute('aria-labelledby','cvc-cart-feedback-title');
 dialog.innerHTML='<button type="button" class="cvc-feedback-close" aria-label="Close cart message">×</button><p class="cvc-feedback-eyebrow">YOUR C.V.C BAG</p><h2 id="cvc-cart-feedback-title"></h2><p class="cvc-feedback-message"></p><a class="cvc-feedback-bag" href="'+store+'/cart">View your bag ↗</a><a class="cvc-feedback-contact" href="'+store+'/pages/contact">Contact C.V.C ↗</a>';
 document.body.append(dialog);
 dialog.querySelector('button').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('close',()=>previousFocus?.focus());
 function showError(title,message){previousFocus=document.activeElement;dialog.querySelector('h2').textContent=title;dialog.querySelector('.cvc-feedback-message').textContent=message;dialog.showModal();}
 document.addEventListener('click',async event=>{
  const action=event.target.closest('[data-cvc-add],[data-cvc-buy]');if(!action)return;
  if(action.getAttribute('aria-disabled')==='true'){event.preventDefault();return;}
  const key=action.dataset.cvcAdd||action.dataset.cvcBuy,offer=data[key];
  if(!offer){event.preventDefault();showError('This option is unavailable.','Please refresh the page or contact C.V.C for help choosing your mask.');return;}
  if(!native)return;
  event.preventDefault();if(busy)return;busy=true;
  const original=action.innerHTML;action.setAttribute('aria-busy','true');action.setAttribute('aria-disabled','true');action.textContent='Adding to your bag…';
  try{
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(offer.variantId),quantity:1}]})});
   const result=await response.json();
   if(!response.ok){
    const message=typeof result.description==='string'?result.description:'That option is unavailable for checkout right now. Please choose another option or contact C.V.C.';
    showError('We couldn’t add that item.',message.slice(0,300));return;
   }
   // Prices, component quantities and availability are enforced by Shopify, never by the browser.
   window.location.assign(root+(action.hasAttribute('data-cvc-buy')?'checkout':'cart'));
  }catch{
   showError('Let’s check your bag.','We couldn’t confirm whether your item was added. Please check your bag before trying again, or contact C.V.C for help.');
  }finally{
   busy=false;action.removeAttribute('aria-busy');action.removeAttribute('aria-disabled');action.innerHTML=original;
  }
 });
 refreshPrices();document.addEventListener('shopify:section:load',refreshPrices);
})();
